const state = {
	algolia: {
		searchResults: [],
		blackBarWidth: '',
		showLoader: false,
		noResults: null
	}
}

const getters = {
	getAlgoliaObject: state => {
		return state.algolia
	},
}

const mutations = {
	updateAlgoliaObject: (state, payload) => {
		state.algolia.searchResults = payload.data
		state.algolia.blackBarWidth = payload.width
		state.algolia.noResults = payload.noResults
		state.algolia.showLoader = payload.showLoader
	}
}

const actions = {
	updateAlgoliaObject: ({
		commit
	}, payload) => {
		commit('updateAlgoliaObject', payload)
	},
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js